<template>
    <div>
        <div class="float-right my-4">
            <button type="button" class="btn btn-primary" @click="loadInfo"
                    data-toggle="modal" data-target="#generate-pdf-modal">{{ $lang('Generuj PDF') }}
            </button>
        </div>

        <div class="modal fade" id="generate-pdf-modal" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="generate-pdf-modal-title">
                            {{ $lang('Generuj PDF dla ankiety') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-2">{{ $lang('Wybierz elementy, które mają znaleźć się na raporcie:') }}</div>
                        <div class="form-check">
                            <input type="checkbox" name="survey_title" v-model="isSurveyTitleIncluded">
                            <label>{{ $lang('Tytuł ankiety') }}</label>
                        </div>
                        <div class="form-check">
                            <input type="checkbox" name="survey_description" v-model="isSurveyDescriptionIncluded">
                            <label>{{ $lang('Opis ankiety') }}</label>
                        </div>
                        <div class="form-check">
                            <input type="checkbox" name="pdf_generation_date" v-model="isReportDateIncluded">
                            <label>{{ $lang('Data wygenerowania raportu') }}</label>
                        </div>
                        <div class="form-check">
                            <input type="checkbox" name="active_filters" v-model="isFiltersListIncluded">
                            <label>{{ $lang('Lista użytych filtrów') }}</label>
                        </div>
                        <div class="form-check">
                            <input type="checkbox" name="libraries" v-model="isLibrariesListIncluded">
                            <label>{{ $lang('Lista bibliotek, które wypełniły ankietę') }}</label>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">{{ $lang('Zamknij') }}
                        </button>
                        <button type="button" class="btn btn-primary" @click="exportPDF">{{
                                $lang('Generuj')
                            }}
                        </button>
                    </div>

                    <div id="generatingMessage" class="text-center py-2" style="display:none;">
                        {{ $lang('Generowanie pliku PDF...') }}
                    </div>

                    <div id="errorMessage" class="text-danger text-center py-2" style="display: none;">
                        {{ $lang('Nie udało się wygenerować pliku PDF.') }}
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "generate-pdf-modal",
    props: {
        csrf: String,
        generate_route: String,
        stats_elements: Array,
        test_summary: {type: Array | null, default: null},
        filter_values: Object,
        survey_type: Object,
        libraries: Object,
        pdf_name: String,
    },
    data() {
        return {
            questionsStatsElements: [],
            testSummary: null,
            selectedStats: null,
            exportData: {
                surveyTypeId: null,
                testSummary: null,
                jsonStats: null,
                surveyTitle: null,
                surveyDescription: null,
                jsonFilterValues: null,
                jsonLibraries: null,
                reportDate: true,
            },
            isReportDateIncluded: true,
            isSurveyTitleIncluded: true,
            isSurveyDescriptionIncluded: true,
            isFiltersListIncluded: true,
            isLibrariesListIncluded: true,
        }
    },
    methods: {
        loadInfo() {
            if (this.survey_type.test === 1) {
                this.testSummary = this.setTestSummaryData(JSON.parse(document.getElementById('test-summary').getAttribute('data-element-stats')));
                this.exportData.testSummary = JSON.stringify(this.testSummary);
            }
            this.questionsStatsElements = [];
            this.stats_elements.forEach(item => {
                this.selectedStats = JSON.parse(document.getElementById('survey-stats-' + item.question_id).getAttribute('data-element-stats'));
                if (item.data.question_type === 1) {
                    this.setTextQuestionStatsElements(item);
                }
                if (item.data.question_type === 2) {
                    this.setTextareaQuestionStatsElements(item);
                }
                if (item.data.question_type === 3) {
                    this.setNumberQuestionStatsElements(item);
                }
                if (item.data.question_type === 4) {
                    this.setDateQuestionStatsElements(item);
                }
                if (item.data.question_type === 5) {
                    this.setCheckboxQuestionStatsElements(item);
                }
                if (item.data.question_type === 6) {
                    this.setRadioQuestionStatsElements(item);
                }
                if (item.data.question_type === 7) {
                    this.setSelectQuestionStatsElements(item);
                }
                if (item.data.question_type === 8) {
                    this.setSelectPeopleQuestionStatsElements(item);
                }
                if (item.data.question_type === 9) {
                    this.setSelectPeopleQuestionStatsElements(item);
                }
                if (item.data.question_type === 10) {
                    this.setSelectDateRangeQuestionStatsElements(item);
                }
            });
            this.exportData.jsonStats = JSON.stringify(this.questionsStatsElements);
            this.exportData.surveyTypeId = this.survey_type['id'];
        },
        setData() {
            if (this.isSurveyTitleIncluded) {
                this.exportData.surveyTitle = this.survey_type.name;
            } else {
                this.exportData.surveyTitle = null;
            }
            if (this.isSurveyDescriptionIncluded) {
                this.exportData.surveyDescription = this.survey_type.description;
            } else {
                this.exportData.surveyDescription = null;
            }
            if (this.isFiltersListIncluded) {
                this.exportData.jsonFilterValues = JSON.stringify(this.filter_values);
            } else {
                this.exportData.jsonFilterValues = null;
            }
            if (this.isLibrariesListIncluded) {
                this.exportData.jsonLibraries = JSON.stringify(this.libraries);
            } else {
                this.exportData.jsonLibraries = null;
            }
            if (this.isReportDateIncluded) {
                this.exportData.reportDate = this.isReportDateIncluded;
            } else {
                this.exportData.reportDate = null;
            }
        },
        exportPDF() {
            this.setData();
            let self = this;
            $("#generatingMessage").show();
            axios({
                method: 'post',
                url: this.generate_route,
                data: this.exportData,
                responseType: 'blob',
            })
                .then(function (response) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    // works in IE11
                    if (typeof window.navigator.msSaveBlob === 'function') {
                        window.navigator.msSaveBlob(
                            response.data,
                            self.pdf_name + '.pdf'
                        );
                    } else {
                        link.setAttribute('download', self.pdf_name + '.pdf');
                        document.body.appendChild(link);
                        link.click();
                    }
                    $("#errorMessage").hide();
                    $("#generate-pdf-modal").modal('hide');
                }).catch(function (error) {
                $("#errorMessage").show();
                console.log(error);
            }).finally(function () {
                $("#generatingMessage").hide();
            });
        },
        setTestSummaryData(testSummaryElement) {
            let completedTestsCount;
            let passedTestsCount;
            let average;
            let median;
            if (testSummaryElement.completedTestsCount) {
                completedTestsCount = this.test_summary.completed_tests_count;
            }
            if (testSummaryElement.passedTestsCount) {
                passedTestsCount = this.test_summary.passed_tests_count;
            }
            if (testSummaryElement.average) {
                average = this.test_summary.average_of_correct_answers_percentage;
            }
            if (testSummaryElement.median) {
                median = this.test_summary.median_of_correct_answers_percentage;
            }
            return {
                selected: testSummaryElement.selected,
                completed_tests_count: completedTestsCount,
                passed_tests_count: passedTestsCount,
                average_of_correct_answers_percentage: average,
                median_of_correct_answers_percentage: median,
            }
        },
        setTextQuestionStatsElements(statsElement) {
            let selected;
            let isCountSelected;
            let answersCount;
            let correctPercentage;
            let answersList;
            for (const [key, value] of Object.entries(this.selectedStats)) {
                if (value.selected !== undefined) {
                    selected = value.selected;
                }
                if (value.answersCount !== undefined) {
                    isCountSelected = value.answersCount;
                    answersCount = statsElement.data.count;
                }
                if (value.correctPercentage !== undefined) {
                    correctPercentage = this.getCorrectPercentage(value.correctPercentage, statsElement);
                }
                if (value.answersList !== undefined) {
                    answersList = this.getAnswersList(value.answersList, statsElement);
                }
            }
            this.questionsStatsElements.push({
                'selected': selected,
                'question_id': statsElement.question_id,
                'is_count_selected': isCountSelected,
                'count': answersCount,
                'correct_percentage': correctPercentage,
                'answers_list': answersList
            });
        },
        setTextareaQuestionStatsElements(statsElement) {
            let selected;
            let isCountSelected;
            let answersCount;
            let correctPercentage;
            let answersList;
            for (const [key, value] of Object.entries(this.selectedStats)) {
                if (value.selected !== undefined) {
                    selected = value.selected;
                }
                if (value.answersCount !== undefined) {
                    isCountSelected = value.answersCount;
                    answersCount = statsElement.data.count;
                }
                if (value.correctPercentage !== undefined) {
                    correctPercentage = this.getCorrectPercentage(value.correctPercentage, statsElement);
                }
                if (value.answersList !== undefined) {
                    answersList = this.getAnswersList(value.answersList, statsElement);
                }
            }
            this.questionsStatsElements.push({
                'selected': selected,
                'question_id': statsElement.question_id,
                'is_count_selected': isCountSelected,
                'count': answersCount,
                'correct_percentage': correctPercentage,
                'answers_list': answersList
            });
        },
        setNumberQuestionStatsElements(statsElement) {
            let selected;
            let isCountSelected;
            let answersCount;
            let correctPercentage;
            let average;
            let median;
            let groupedAnswers;
            for (const [key, value] of Object.entries(this.selectedStats)) {
                if (value.selected !== undefined) {
                    selected = value.selected;
                }
                if (value.answersCount !== undefined) {
                    isCountSelected = value.answersCount;
                    answersCount = statsElement.data.count;
                }
                if (value.correctPercentage !== undefined) {
                    correctPercentage = this.getCorrectPercentage(value.correctPercentage, statsElement);
                }
                if (value.average !== undefined) {
                    average = this.getAverage(value.average, statsElement);
                }
                if (value.median !== undefined) {
                    median = this.getMedian(value.median, statsElement);
                }
                if (value.groupedAnswers !== undefined) {
                    groupedAnswers = this.getGroupedAnswers(value.groupedAnswers, statsElement);
                }
            }
            this.questionsStatsElements.push({
                'selected': selected,
                'question_id': statsElement.question_id,
                'is_count_selected': isCountSelected,
                'count': answersCount,
                'correct_percentage': correctPercentage,
                'average': average,
                'median': median,
                'grouped': groupedAnswers
            });
        },
        setDateQuestionStatsElements(statsElement) {
            let selected;
            let isCountSelected;
            let answersCount;
            let correctPercentage;
            let groupedAnswers;
            for (const [key, value] of Object.entries(this.selectedStats)) {
                if (value.selected !== undefined) {
                    selected = value.selected;
                }
                if (value.answersCount !== undefined) {
                    isCountSelected = value.answersCount;
                    answersCount = statsElement.data.count;
                }
                if (value.correctPercentage !== undefined) {
                    correctPercentage = this.getCorrectPercentage(value.correctPercentage, statsElement);
                }
                if (value.groupedAnswers !== undefined) {
                    groupedAnswers = this.getGroupedAnswers(value.groupedAnswers, statsElement);
                }
            }
            this.questionsStatsElements.push({
                'selected': selected,
                'question_id': statsElement.question_id,
                'is_count_selected': isCountSelected,
                'count': answersCount,
                'correct_percentage': correctPercentage,
                'grouped': groupedAnswers
            });
        },
        setCheckboxQuestionStatsElements(statsElement) {
            let selected;
            let isCountSelected;
            let answersCount;
            let correctPercentage;
            let average;
            let median;
            let groupedAnswers;
            for (const [key, value] of Object.entries(this.selectedStats)) {
                if (value.selected !== undefined) {
                    selected = value.selected;
                }
                if (value.answersCount !== undefined) {
                    isCountSelected = value.answersCount;
                    answersCount = statsElement.data.count;
                }
                if (value.correctPercentage !== undefined) {
                    correctPercentage = this.getCorrectPercentage(value.correctPercentage, statsElement);
                }
                if (value.average !== undefined) {
                    average = this.getAverage(value.average, statsElement);
                }
                if (value.median !== undefined) {
                    median = this.getMedian(value.median, statsElement);
                }
                if (value.groupedAnswers !== undefined) {
                    groupedAnswers = this.getGroupedAnswers(value.groupedAnswers, statsElement);
                }
            }
            this.questionsStatsElements.push({
                'selected': selected,
                'question_id': statsElement.question_id,
                'is_count_selected': isCountSelected,
                'count': answersCount,
                'correct_percentage': correctPercentage,
                'average': average,
                'median': median,
                'grouped': groupedAnswers
            });
        },
        setRadioQuestionStatsElements(statsElement) {
            let selected;
            let isCountSelected;
            let answersCount;
            let correctPercentage;
            let average;
            let median;
            let groupedAnswers;
            for (const [key, value] of Object.entries(this.selectedStats)) {
                if (value.selected !== undefined) {
                    selected = value.selected;
                }
                if (value.answersCount !== undefined) {
                    isCountSelected = value.answersCount;
                    answersCount = statsElement.data.count;
                }
                if (value.correctPercentage !== undefined) {
                    correctPercentage = this.getCorrectPercentage(value.correctPercentage, statsElement);
                }
                if (value.average !== undefined) {
                    average = this.getAverage(value.average, statsElement);
                }
                if (value.median !== undefined) {
                    median = this.getMedian(value.median, statsElement);
                }
                if (value.groupedAnswers !== undefined) {
                    groupedAnswers = this.getGroupedAnswers(value.groupedAnswers, statsElement);
                }
            }
            this.questionsStatsElements.push({
                'selected': selected,
                'question_id': statsElement.question_id,
                'is_count_selected': isCountSelected,
                'count': answersCount,
                'correct_percentage': correctPercentage,
                'average': average,
                'median': median,
                'grouped': groupedAnswers
            });
        },
        setSelectQuestionStatsElements(statsElement) {
            let selected;
            let isCountSelected;
            let answersCount;
            let correctPercentage;
            let average;
            let median;
            let groupedAnswers;
            for (const [key, value] of Object.entries(this.selectedStats)) {
                if (value.selected !== undefined) {
                    selected = value.selected;
                }
                if (value.answersCount !== undefined) {
                    isCountSelected = value.answersCount;
                    answersCount = statsElement.data.count;
                }
                if (value.correctPercentage !== undefined) {
                    correctPercentage = this.getCorrectPercentage(value.correctPercentage, statsElement);
                }
                if (value.average !== undefined) {
                    average = this.getAverage(value.average, statsElement);
                }
                if (value.median !== undefined) {
                    median = this.getMedian(value.median, statsElement);
                }
                if (value.groupedAnswers !== undefined) {
                    groupedAnswers = this.getGroupedAnswers(value.groupedAnswers, statsElement);
                }
            }
            this.questionsStatsElements.push({
                'selected': selected,
                'question_id': statsElement.question_id,
                'is_count_selected': isCountSelected,
                'count': answersCount,
                'correct_percentage': correctPercentage,
                'average': average,
                'median': median,
                'grouped': groupedAnswers
            });
        },
        setSelectPeopleQuestionStatsElements(statsElement) {
            let selected;
            let isCountSelected;
            let answersCount;
            let correctPercentage;
            let groupedAnswers;
            for (const [key, value] of Object.entries(this.selectedStats)) {
                if (value.selected !== undefined) {
                    selected = value.selected;
                }
                if (value.answersCount !== undefined) {
                    isCountSelected = value.answersCount;
                    answersCount = statsElement.data.count;
                }
                if (value.correctPercentage !== undefined) {
                    correctPercentage = this.getCorrectPercentage(value.correctPercentage, statsElement);
                }
                if (value.groupedAnswers !== undefined) {
                    groupedAnswers = this.getGroupedAnswers(value.groupedAnswers, statsElement);
                }
            }
            this.questionsStatsElements.push({
                'selected': selected,
                'question_id': statsElement.question_id,
                'is_count_selected': isCountSelected,
                'count': answersCount,
                'correct_percentage': correctPercentage,
                'grouped': groupedAnswers
            });
        },
        setSelectDateRangeQuestionStatsElements(statsElement) {
            let selected;
            let isCountSelected;
            let answersCount;
            let correctPercentage;
            let groupedAnswers;
            for (const [key, value] of Object.entries(this.selectedStats)) {
                if (value.selected !== undefined) {
                    selected = value.selected;
                }
                if (value.answersCount !== undefined) {
                    isCountSelected = value.answersCount;
                    answersCount = statsElement.data.count;
                }
                if (value.correctPercentage !== undefined) {
                    correctPercentage = this.getCorrectPercentage(value.correctPercentage, statsElement);
                }
                if (value.groupedAnswers !== undefined) {
                    groupedAnswers = this.getGroupedAnswers(value.groupedAnswers, statsElement);
                }
            }
            this.questionsStatsElements.push({
                'selected': selected,
                'question_id': statsElement.question_id,
                'is_count_selected': isCountSelected,
                'count': answersCount,
                'correct_percentage': correctPercentage,
                'grouped': groupedAnswers
            });
        },
        getAnswersList(isAnswersListSelected, statsElement) {
            if (isAnswersListSelected) {
                return statsElement.data.answers_list;
            } else {
                return null;
            }
        },
        getCorrectPercentage(isCorrectPercentageSelected, statsElement) {
            if (isCorrectPercentageSelected) {
                return statsElement.data.correct_percentage;
            } else {
                return null;
            }
        },
        getAverage(isAverageSelected, statsElement) {
            if (isAverageSelected) {
                return statsElement.data.average;
            } else {
                return null;
            }
        },
        getMedian(isMedianSelected, statsElement) {
            if (isMedianSelected) {
                return statsElement.data.median;
            } else {
                return null;
            }
        },
        getGroupedAnswers(areGroupedAnswersSelected, statsElement) {
            if (areGroupedAnswersSelected) {
                return statsElement.data.grouped;
            } else {
                return null;
            }
        }
    }
}
</script>

<style scoped>

</style>
